const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(
      null,
      Array.from(bytes.subarray(i, i + chunk)),
    );
  }
  return btoa(binary);
};

export async function replaceDocumentWithDocx(buffer: ArrayBuffer) {
  const base64 = arrayBufferToBase64(buffer);
  await Word.run(async (ctx) => {
    ctx.document.body.insertFileFromBase64(base64, Word.InsertLocation.replace);
    await ctx.sync();
  });
}

export async function insertHtml(html: string) {
  await Word.run(async (ctx) => {
    const range = ctx.document.getSelection();
    range.insertHtml(html, Word.InsertLocation.replace);
    await ctx.sync();
  });
}

export async function getDocumentAsDocx(): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    Office.context.document.getFileAsync(
      Office.FileType.Compressed,
      { sliceSize: 65536 },
      (result) => {
        if (result.status !== Office.AsyncResultStatus.Succeeded) {
          reject(new Error(result.error?.message ?? 'getFile_failed'));
          return;
        }
        const file = result.value;
        const slices: Uint8Array[] = [];
        let total = 0;
        const readSlice = (index: number) => {
          file.getSliceAsync(index, (sliceResult) => {
            if (sliceResult.status !== Office.AsyncResultStatus.Succeeded) {
              file.closeAsync();
              reject(new Error(sliceResult.error?.message ?? 'getSlice_failed'));
              return;
            }
            const data = sliceResult.value.data as number[];
            const bytes = Uint8Array.from(data);
            slices.push(bytes);
            total += bytes.length;
            if (index + 1 < file.sliceCount) {
              readSlice(index + 1);
            } else {
              file.closeAsync(() => {
                const merged = new Uint8Array(total);
                let offset = 0;
                for (const slice of slices) {
                  merged.set(slice, offset);
                  offset += slice.length;
                }
                resolve(merged.buffer);
              });
            }
          });
        };
        if (file.sliceCount === 0) {
          file.closeAsync(() => resolve(new ArrayBuffer(0)));
          return;
        }
        readSlice(0);
      },
    );
  });
}
